/* tslint:disable */
/* eslint-disable */
/**
 * Apideck
 * The Apideck OpenAPI Spec: SDK Optimized
 *
 * The version of the OpenAPI document: 10.13.0
 * Contact: support@apideck.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Consumer, ConsumerFromJSON, ConsumerToJSON } from './Consumer'
import { Raw, RawFromJSON, RawToJSON } from './Raw'

/**
 *
 * @export
 * @interface UpdateConsumerResponse
 */
export interface UpdateConsumerResponse {
  /**
   * HTTP Response Status Code
   * @type {number}
   * @memberof UpdateConsumerResponse
   */
  status_code: number
  /**
   * HTTP Response Status
   * @type {string}
   * @memberof UpdateConsumerResponse
   */
  status: string
  /**
   *
   * @type {Consumer}
   * @memberof UpdateConsumerResponse
   */
  data: Consumer
  /**
   *
   * @type {Raw}
   * @memberof UpdateConsumerResponse
   */
  _raw?: Raw | null
}

export function UpdateConsumerResponseFromJSON(json: any): UpdateConsumerResponse {
  return UpdateConsumerResponseFromJSONTyped(json, false)
}

export function UpdateConsumerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateConsumerResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status_code: json['status_code'],
    status: json['status'],
    data: ConsumerFromJSON(json['data']),
    _raw: !exists(json, '_raw') ? undefined : RawFromJSON(json['_raw'])
  }
}

export function UpdateConsumerResponseToJSON(value?: UpdateConsumerResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status_code: value.status_code,
    status: value.status,
    data: ConsumerToJSON(value.data),
    _raw: RawToJSON(value._raw)
  }
}
